/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import { Button, Drawer, Flex, message } from "antd";
import { Row, Col, Space, Form, Divider, Input, Steps } from "antd";

import {
  LeftOutlined,
  SaveFilled,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";

// import { delay } from '../../utils/util';
// import OptionService from '../../service/Options.service';
import TreatmentService from "../../../service/Treatment.service.js";
// import OptionService from '../../service/Options.service';
import { useForm } from "antd/es/form/Form";
import { initialSteps } from "./modal-treatment.model";

const tmservice = TreatmentService();
// const opservice = OptionService();
const ModalTreatmentManage = ({ config, open, close, complete }) => {
  const [formData, setFormData] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [form] = useForm();

  const [steps, setSteps] = useState(initialSteps);

  const half = Math.ceil(steps.length / 2);
  const steps1 = steps.slice(0, half);
  const steps2 = steps.slice(half);
  // const [packageTypeOption, setPackageTypeOption] = useState([]);
  const init = async () => {
    if (config?.action !== "create") {
      tmservice
        .get(config?.code, { ignoreLoading: true })
        .then(async (res) => {
          const { data } = res.data;
          formData(data);
        })
        .catch((err) => {
          // console.warn(err);
          const { data } = err.response;
          message.error(data?.message || "error request");
        });
    }
  };

  useEffect(() => {
    init();

    setOpenDrawer(open);
    return () => {
      setFormData(null);
    };
  }, [open]);

  // เพิ่มขั้นตอนใหม่
  const handleAddStep = () => {
    setSteps([
      ...steps,
      {
        step_name: `Step ${steps.length + 1}`,
        editable: true,
      },
    ]);
    // setCurrent(steps.length); // ไปที่ step ใหม่
  };

  // แก้ไขชื่อหรือรายละเอียดขั้นตอน
  const handleEditStep = (index, field, value) => {
    const newSteps = [...steps];
    newSteps[index][field] = value;
    setSteps(newSteps);
  };

  // ลบขั้นตอน
  const handleDeleteStep = (index) => {
    const newSteps = steps.filter((_, i) => i !== index);
    setSteps(newSteps);
  };

  const handleConfirm = (header) => {
    const parm = { header, steps: steps };
    const conf = { ignoreLoading: true };
    // console.log("parm", parm);
    const actions =
      config?.action !== "create"
        ? tmservice.update(parm, conf)
        : tmservice.create(parm, conf);

    actions
      .then(async (r) => {
        message.success("Request success.");
        complete(false);
      })
      .catch((err) => {
        console.warn(err);
        const data = err?.response?.data;
        message.error(data?.message || "error request");
      });
  };

  const Detail = () => (
    <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
      <Col xs={24} sm={24} md={24} lg={14} xl={14} xxl={14}>
        <Form.Item
          label="Treatment Name"
          name="tm_name"
          rules={[{ required: true, message: "Please enter data!" }]}
        >
          <Input placeholder="Enter Treatment Name" />
        </Form.Item>
      </Col>
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <Button
            icon={<LeftOutlined style={{ fontSize: "1rem" }} />}
            style={{ width: "9.5rem" }}
            className="bn-center"
            onClick={() => setOpenDrawer(false)}
          >
            Back
          </Button>
        </Flex>
      </Col>
      <Col span={12} className="p-0">
        <Flex gap={4} justify="end">
          <Button
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            onClick={() => {
              form
                .validateFields()
                .then((values) => {
                  handleConfirm(values);
                })
                .catch((info) => {
                  console.log("Validate Failed:", info);
                });
            }}
            style={{ width: "9.5rem" }}
          >
            Save
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  return (
    <div className="modal-banks-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Drawer
        title={config?.title}
        onClose={() => {
          setOpenDrawer(false);
        }}
        open={openDrawer}
        width={1000}
        className="responsive-drawer"
        // getContainer={() => document.querySelector(".loadingtype-manage")}
        footer={SectionBottom}
        afterOpenChange={(e) => {
          if (!e) {
            close(false);
          }
        }}
        maskClosable={false}
      >
        {openDrawer && (
          <Space direction="vertical" className="flex gap-2">
            <Form form={form} layout="vertical" autoComplete="off">
              <Divider orientation="left" plain style={{ margin: 10 }}>
                {" "}
                Information Detail{" "}
              </Divider>
              <Detail />
            <Divider orientation="left" plain style={{ margin: 10 }}>
              {" "}
              Steps Manage{" "}
            </Divider>
            {/* <StepsManage /> */}
            <Steps
        current={-1}
        direction="horizontal"
        items={steps1.map((step, idx) => ({
          title: (
            <Space>
              <Input
                value={step.step_name}
                onChange={(e) => handleEditStep(idx, "step_name", e.target.value)}
                style={{ width: 80 }}
                size="small"
              />
              <Button
                icon={<DeleteOutlined />}
                size="small"
                danger
                onClick={() => handleDeleteStep(idx)}
              />
            </Space>
          ),
        }))}
      />
            <Steps
        current={-1}
        direction="horizontal"
        items={steps2.map((step, idx) => ({
          title: (
            <Space>
              <Input
                value={step.step_name}
                onChange={(e) =>
                  handleEditStep(idx + half, "step_name", e.target.value)
                }
                style={{ width: 80 }}
                size="small"
              />
              <Button
                icon={<DeleteOutlined />}
                size="small"
                danger
                onClick={() => handleDeleteStep(idx + half)}
              />
            </Space>
          ),
        }))}
        style={{ marginTop: 16 }}
      />
      <div style={{ marginTop: 24, textAlign: "center" }}>
        <Button
          type="dashed"
          icon={<PlusCircleOutlined />}
          onClick={handleAddStep}
        >
          เพิ่มขั้นตอนใหม่
        </Button>
      </div>
            </Form>
          </Space>
        )}
      </Drawer>
    </div>
  );
};

export default ModalTreatmentManage;
